export default import.meta.ROLLDOWN_FILE_URL_VfJm2ZZKT9OX2CjveQ8jRA